export const GET_ALL_PRODUCTS_REQUEST = "GET_ALL_PRODUCTS_REQUEST";
export const GET_ALL_PRODUCTS = "GET_ALL_PRODUCTS";
export const GET_ALL_PRODUCTS_FAIL = "GET_ALL_PRODUCTS_FAIL";
export const GET_SINGLE_PRODUCT = "GET_SINGLE_PRODUCT";
export const GET_SINGLE_PRODUCT_REQUEST = "GET_SINGLE_PRODUCT_REQUEST";
export const GET_ALL_BASKETS = "GET_ALL_BASKETS";
export const GET_ALL_BASKETS_REQUEST = "GET_ALL_BASKETS_REQUEST";
export const GET_ALL_BASKETS_FAIL = "GET_ALL_BASKETS_FAIL";
